<template>
  <div class="salesman-form main-container" v-loading="loading">
    <Tabs v-model="tabId" :animated="false" @on-click="tabChange">
      <div class="top">
        <Button type="primary" ghost v-if="tabId == 'policyInfo'" @click="backPage()">{{ ['policyInfo'].includes(tabId) ? '取消' : '返回' }}</Button>
        <Button type="primary" v-if="tabId == 'policyInfo'" @click="save(false)" :loading="saveLoading">保存</Button>
        <!-- <Button class="save-btn3" type="warning" v-if="editFlag == 'add'" @click="save(true)" :loading="saveLoading">存草稿</Button> -->
      </div>
      <div style="height: 20px"></div>
      <TabPane v-for="bean in tabList" :key="bean.id" :label="bean.name" :name="bean.id"> </TabPane>
    </Tabs>
    <!-- 保单信息 -->
    <policy-info v-show="tabId == 'policyInfo'" ref="policyInfo" @save="reload" :policyNo="policyNo" :editFlag="editFlag"></policy-info>
    <!-- 人员信息 -->
    <personnel-info v-show="tabId == 'personnelInfo'" ref="personnelInfo" @save="reload" :policyNo="policyNo" :editFlag="editFlag"></personnel-info>
    <!-- 保全信息 -->
    <preservation-info
      v-show="tabId == 'preservationInfo'"
      ref="preservationInfo"
      @save="reload"
      :policyNo="policyNo"
      :editFlag="editFlag"
      :endTime="endTime"
    ></preservation-info>
  </div>
</template>

<script>
import { common } from '@/api/mixins';
import policyInfo from './tabs/policyInfoForm';
import personnelInfo from './tabs/personnelInfoList';
import preservationInfo from './tabs/preservationInfoList';

export default {
  mixins: [common],
  components: {
    policyInfo,
    personnelInfo,
    preservationInfo
  },
  data() {
    return {
      loading: false,
      tabId: 'policyInfo',
      tabList: [
        { id: 'policyInfo', name: '保单信息', },
        { id: 'personnelInfo', name: '人员信息', },
        { id: 'preservationInfo', name: '保全信息', }
      ],
      saveList: ['policyInfo'],
      policyNo: '',
      endTime: '',
      saveLoading: false,
      editFlag: ''
    };
  },

  created() {
    this.policyNo = this.$route.query.policyNo;
    this.editFlag = this.$route.query.editFlag;
  },

  methods: {
    async save(isDraft) {
      try {
        if (this.loading) {
          return;
        }
        this.loading = true;
        this.saveLoading = true;
        for (let i = 0; i < this.saveList.length; i++) {
          await this.$refs[this.saveList[i]].save(isDraft);
        }
        this.loading = false;
        this.saveLoading = false;
      } catch (e) {
        console.log(e);
        this.loading = false;
        this.saveLoading = false;
        if (e.showMsg) {
          this.$notice.msg('请完善信息');
        }
        if (e.page) {
          this.tabId = e.page;
        }
      }
    },

    reload(data) {
      this.policyNo = data.groupPolicy.policyNo;
      this.endTime = data.groupPolicy.endTime;
    },

    tabChange() {
      if (!this.policyNo || this.editFlag == 'copy') {
        this.$nextTick(() => {
          this.tabId = 'policyInfo';
        });
        this.$notice.msg('数据尚未保存');
        return;
      }
      if (!this.saveList.includes(this.tabId)) {
        this.saveList.push(this.tabId);
      }
      if(this.tabId == 'preservationInfo') {
        this.$refs.preservationInfo.setData();
      } else if(this.tabId == 'personnelInfo') {
        this.$refs.personnelInfo.setData();
      }
    },

    backPage() {
      if(this.$route.query.workName == 'workName'){
        this.back('/workbench/index');
      }else{
        this.back('/orderManage/group/policy');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.salesman-form {
  position: relative;

  /deep/ .ivu-tabs-nav-scroll {
    top: 0;
    padding-top: 10px;
    position: fixed;
    width: 98%;
    z-index: 1;
    background: #fff;
  }

  .top {
    position: fixed;
    right: 20px;
    z-index: 2;
    top: 15px;
    .save-btn {
      position: absolute;
      right: 90px;
      top: 1px;
      z-index: 10;
      height: 30px;
      width: 80px;
      border-radius: 2px;
      font-size: 12px;

      &.save-btn2 {
        right: 190px;
      }
    }
    .save-btn3 {
      width: 80px;
    }
  }

  /deep/ {
    .ivu-tabs-bar {
      border-bottom: 1px solid #ececec;
    }

    .ivu-tabs-ink-bar {
      display: none;
    }

    .ivu-tabs-tab {
      padding: 4px 0 10px;
      margin-right: 44px;
      font-size: 14px;
      color: #515c6f;
    }

    .ivu-tabs-tab-active {
      position: relative;
      color: #236dff;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        bottom: 1px;
        height: 2px;
        width: 100%;
        background-color: #236dff;
      }
    }

    .ivu-tabs-nav-container,
    .ivu-tabs-nav-wrap {
      overflow: visible;
    }
  }
}
</style>
